export default __webpack_public_path__ + "static/media/icon_location.09b33df6.svg";